import type { Localized, SurveyInput, SurveyQuestion } from "./types";

export interface TextField {
  label: string;
  value: Localized;
  apply: (s: SurveyInput, value: Localized) => SurveyInput;
}

const withQuestion = (s: SurveyInput, i: number, q: SurveyQuestion): SurveyInput => ({
  ...s,
  questions: s.questions.map((x, j) => (j === i ? q : x)),
});

/** Every EN/HI text in the survey, in reading order (Translations tab). */
export function listTexts(s: SurveyInput): TextField[] {
  const c = s.content;
  const out: TextField[] = [
    { label: "Intro title", value: c.intro.title, apply: (x, v) => ({ ...x, content: { ...x.content, intro: { ...x.content.intro, title: v } } }) },
    { label: "Intro text", value: c.intro.body, apply: (x, v) => ({ ...x, content: { ...x.content, intro: { ...x.content.intro, body: v } } }) },
    { label: "Thank-you title", value: c.thankYou.title, apply: (x, v) => ({ ...x, content: { ...x.content, thankYou: { ...x.content.thankYou, title: v } } }) },
    { label: "Thank-you text", value: c.thankYou.body, apply: (x, v) => ({ ...x, content: { ...x.content, thankYou: { ...x.content.thankYou, body: v } } }) },
  ];
  if (c.feedback.enabled) {
    out.push({ label: "Feedback prompt", value: c.feedback.prompt, apply: (x, v) => ({ ...x, content: { ...x.content, feedback: { ...x.content.feedback, prompt: v } } }) });
  }
  s.questions.forEach((q, i) => {
    const n = `Q${i + 1}`;
    out.push({ label: n, value: q.text, apply: (x, v) => withQuestion(x, i, { ...x.questions[i], text: v }) });
    q.options?.forEach((o, j) => {
      out.push({
        label: `${n} · option ${j + 1}`,
        value: o.text,
        apply: (x, v) =>
          withQuestion(x, i, {
            ...x.questions[i],
            options: x.questions[i].options!.map((oo, k) => (k === j ? { ...oo, text: v } : oo)),
          }),
      });
    });
    if (q.nps) {
      out.push({ label: `${n} · low label`, value: q.nps.lowLabel, apply: (x, v) => withQuestion(x, i, { ...x.questions[i], nps: { ...x.questions[i].nps!, lowLabel: v } }) });
      out.push({ label: `${n} · high label`, value: q.nps.highLabel, apply: (x, v) => withQuestion(x, i, { ...x.questions[i], nps: { ...x.questions[i].nps!, highLabel: v } }) });
    }
  });
  return out;
}
